import styled from "styled-components";
import { useEffect, useState, useRef, useContext } from "react";
import { DialogWindowContext } from "../../Contexts/DialogueWindowContext";
import { SpinnerContext } from "../../Contexts/SpinnerContext";
import {
  addDocument,
  addCheatSheetToDatabase,
  deleteFolderContents,
  deleteCheatSheet,
} from "../../Firebase";

import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";
import { generateRandomString } from "../../Helpers/ReportDataFunctions";

const EditWrapper = styled.div`
  width: fit-content;

  .p-inputtext {
    width: 100%;
    margin: 10px 0;
  }

  .p-fileupload {
    width: 100%;
    margin: 10px 0;
  }

  p{
    margin: 10px 0 15px 0;
    font-size: 13px;
  }

  h3{
    font-size: 15px;
  }
`;

export default function UserEdit(props: Props) {
  const { cheatSheet } = props;
  const Spinner = useContext(SpinnerContext);
  const [newCheatSheet, setNewCheatSheet] = useState<CheatSheet>();
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const DialogWindow = useContext(DialogWindowContext);

  useEffect(() => {
    cheatSheet && setNewCheatSheet(cheatSheet);
  }, [cheatSheet]);

  const saveCheatSheet = async () => {
    if (newCheatSheet) {
        Spinner.setIsLoading(true);
      // Ensure newCheatSheet is defined
      const cheatSheetId = newCheatSheet.cheatSheetId || generateRandomString();
      let newUrl = cheatSheet.url;
      if (uploadedFile) {
        await deleteFolderContents(cheatSheetId);
        await addDocument(uploadedFile, cheatSheetId).then((url) => {
          url && setNewCheatSheet({ ...newCheatSheet, cheatSheetId, url });
          if (url) newUrl = url;
        });
      }
      const newCheatSheetWithUrl = {
        ...newCheatSheet,
        cheatSheetId,
        url: newUrl,
      };
      addCheatSheetToDatabase(newCheatSheetWithUrl);

      // Save newCheatSheet to the Firestore CheatSheets collection
      Spinner.setIsLoading(false);
      DialogWindow.setDialogProps({
        ...DialogWindow,
        showEditWindow: false,
      });
    }
  };

  function onSelect(event: any) {
    const file = event.files[0];
    setUploadedFile(file);
  }

  function extractFileNameFromFirebaseURL(url: string): string {
    // Split the URL by slashes
    const parts = url.split("/");

    // Find the part that contains the file name
    const fileNamePart = parts.find((part) => part.includes("%2F")) || "";

    // Decode the URI component to get the actual file name
    const decodedFileName = decodeURIComponent(
      fileNamePart.split("%2F").pop() || ""
    );

    return decodedFileName.split("?")[0]; // Remove any query parameters
  }

  return (
    <EditWrapper>
      <h3>CheatSheet Title</h3>
      <InputText
        placeholder="Title"
        value={newCheatSheet?.title || ""}
        onChange={(event) => {
          if (newCheatSheet) {
            setNewCheatSheet({
              ...newCheatSheet,
              title: event.currentTarget.value,
            });
          }
        }}
      />
      {newCheatSheet?.url && (
        <>
          <h3>Current File</h3>
          <p>{extractFileNameFromFirebaseURL(newCheatSheet?.url)}</p>
        </>
      )}
      <FileUpload
        url={newCheatSheet?.url}
        mode="basic"
        accept=".pdf"
        onSelect={onSelect}
        chooseLabel="New File"
      />
      <Button severity="success" label="Save" onClick={saveCheatSheet} />
    </EditWrapper>
  );
}

interface Props {
  cheatSheet: CheatSheet;
}
